import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
`;

export const TableHead = styled.thead`
  background-color: #f5f5f5;

  tr {
    border: #f5f5f5 solid;
  }

  th {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 14px;
    text-align: left;
    padding: 12px;
    color: #696969;
    &:nth-child(1) { width: 60px; } /* Coluna do Switch */
    &:nth-child(2) { width: 100px; } /* Código */
    &:nth-child(3) { width: 15%; } /* Produto */
    &:nth-child(4) { width: 10%; } /* Coleção */ 
    &:nth-child(5) { width: 10%; } /* Família */
    &:nth-child(6) { width: 10%; } /* Grupo */
    &:nth-child(7) { width: 20%; } /* Cores */
    &:nth-child(8) { width: 15%; } /* Graduação */
    &:nth-child(9) { width: 120px; } /* Preço */
    &:nth-child(10) { width: 100px; } /* Ações (ícones) */
  }
`;

export const TableRow = styled.tr`
  border-bottom: 1.5px solid #f3f3f3;
  td {
    background-color: #ffffff;
  }
`;

export const FooterRow = styled.tr`
  td {
    background-color: transparent;
  }
  &:hover {
    background-color: transparent;
  }
`;

export const TableCell = styled.td`
  padding: 12px 8px;
  text-align: left;
  vertical-align: middle;

  &:nth-child(1) { width: 60px; } /* Coluna do Switch */
  &:nth-child(2) { width: 100px; } /* Código */
  &:nth-child(3) { width: 15%; } /* Produto */
  &:nth-child(4) { width: 10%; } /* Coleção */
  &:nth-child(5) { width: 10%; } /* Família */
  &:nth-child(6) { width: 10%; } /* Grupo */
  &:nth-child(7) { width: 20%; } /* Cores */
  &:nth-child(8) { width: 15%; } /* Graduação */
  &:nth-child(9) { width: 120px; } /* Preço */
  &:nth-child(10) { width: 100px; } /* Ações (ícones) */
`;

export const EllipsisTableCell = styled(TableCell)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const PageContainer = styled.div`
  padding: 16px;
  background-color: #f5f5f5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
`;

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  margin-left: 32px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
`;

export const FilterButton = styled.button`
  background-color: white;
  border: 1px solid #009DFF;
  color: #009DFF;
  padding: 8px 16px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const NewProductButton = styled.button`
  background-color: #009DFF;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const TableHeaderContainer = styled.div`
  background-color: #ffffff;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 0;
  margin-bottom: -1px;
  position: relative;
  z-index: 2;

  ${Table} {
    margin-bottom: 0;
    border-bottom: none;
  }

  ${TableHead} {
    background-color: #f5f5f5;
    position: static;
    top: auto;
    z-index: auto;
    border-radius: 0;
  }

  ${TableRow} {
    border-bottom: 1.5px solid #f3f3f3;
  }

  ${TableCell} {
    background-color: #f5f5f5;
  }
`;

export const TableWrapper = styled.div`
  background-color: #ffffff;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 0;
  overflow-x: auto;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);

  min-height: 0;
  height: auto;
  max-height: calc(100vh - 250px); 

  overflow-y: auto;
  overflow-x: hidden;

  ${Table} {
    margin-top: -1px;
    border-top: none;
  }

  ${TableHead} {
    display: none;
  }
`;